import { createContext } from 'react';

import { CurrentVip } from '@/store/User';

import { Commodity } from './const';
import { UseValidateReturn } from './hooks/useValidate';
import { LimitConfig } from './type';

/**
 * 获取用户登录状态的选项
 */
export interface GetUserLoginStateOptions {
  /**
   * 用户就绪后的回调（已登录或登录成功且权限刷新后都会执行）
   * 这是执行业务逻辑的统一入口
   */
  onReady?: () => void;
  /**
   * 是否跳过弹窗，仅检查登录状态
   * 设置为 true 时，如果未登录会直接返回 false，不会弹出登录窗口
   */
  skipLoginModal?: boolean;
  /**
   * 在弹窗显示前执行的逻辑
   * 可以用于在弹窗前做一些准备工作或提示
   */
  onBeforeLogin?: () => void | Promise<void>;
}

export type ContextData = {
  /**
   * 全局权益配置
   */
  limitConfig: LimitConfig;
  /**
   * 单次商品配置
   */
  singlePurchaseConfig: Commodity;
  /**
   * 当前用户身份
   */
  currentVip: CurrentVip;

  /**
   * 刷新权益配置
   */
  withUpdate: (thenDo?: (data: ContextData) => void, searchSeat?: boolean) => void;

  /**
   * 检查用户登录状态，支持多种场景：
   * - 默认：检查登录状态，未登录则弹出登录弹窗
   * - skipModal: true - 仅检查状态，不弹窗
   * - onReady - 登录成功且权限刷新后执行回调
   * - beforeShowModal - 在弹窗前执行自定义逻辑
   * @param options - 可选配置
   * @returns Promise<boolean> - true表示已登录或登录成功，false表示未登录或登录失败
   */
  getUserLoginState: (options?: GetUserLoginStateOptions) => Promise<boolean>;

  /**
   * 获取当前登录状态（同步方法，不弹窗）
   * @returns boolean - true表示已登录，false表示未登录
   */
  getIsLoggedIn: () => boolean;
} & UseValidateReturn;

export const RightContext = createContext<ContextData>({} as ContextData);
